import React from "react";
import { Nav } from "react-bootstrap";
import useReactRouter from "use-react-router";
import routes from "../../../constants/routes";

const NavItem = ({ text, onClick, key, active }) => {
  return (
    <Nav.Item
      style={{
        borderBottom: active ? "1px solid #FAFAFA" : "1px solid #FAFAFA",
      }}
    >
      <Nav.Link
        eventKey={key}
        onClick={onClick}
        style={{
          border: "solid 0px",
          color: active ? "blue" : "#000000",
          fontStyle: "FontLao2",
        }}
      >
        {text}
      </Nav.Link>
    </Nav.Item>
  );
};

function InvoiceTab() {
  const { history, location } = useReactRouter();

  const isActiveTab = (pathname) => location.pathname === pathname;
  return (
    <div>
      <Nav variant="tabs" style={{ border: "solid 0px" }}>
        {/* <NavItem
          onClick={() => history.replace(routes.INVOICES)}
          text="ສະແດງທັງໝົດ"
          active={isActiveTab(routes.INVOICES)}
        /> */}

        <NavItem
          onClick={() => history.replace(routes.CREATE_INVOICE)}
          text="ອໍເດີເຂົ້າທັງໝົດ"
          active={isActiveTab(routes.CREATE_INVOICE)}
        />

         <NavItem
          onClick={() => history.replace(routes.REQUESTING_INVOICE)}
          text="ລາຍການທີ່ກຳລັງແຈ້ງຖອນ"
          active={isActiveTab(routes.REQUESTING_INVOICE)}
        />
          {/* <NavItem
          onClick={() => history.replace(routes.REQUERSTING_INVOICE_AFFILIATE)}
          text="ອໍເດີ້ເຂົ້າຈາກ Affiliate"
          active={isActiveTab(routes.REQUERSTING_INVOICE_AFFILIATE)}
        /> */}
      </Nav>
    </div>
  );
}

export default InvoiceTab;
